module.exports = __webpack_public_path__ + "static/img/chuguan.2b6cbed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuguan.svg
// module id = Tkls
// module chunks = 1